var _g, _g2, _g3, _g4, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    version: 1.1,
    id: "Layer_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 181 181",
    enableBackground: "new 0 0 181 181",
    xmlSpace: "preserve"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Base_Circle",
    display: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    display: "inline",
    opacity: 0.4,
    fill: "#FFFFFF",
    stroke: "#000000",
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    cx: 641,
    cy: -1296.734,
    r: 77.25
  }), /*#__PURE__*/React.createElement("circle", {
    display: "inline",
    opacity: 0.4,
    fill: "#FFFFFF",
    stroke: "#000000",
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    cx: 1319.5,
    cy: -1296.734,
    r: 77.25
  }), /*#__PURE__*/React.createElement("circle", {
    display: "inline",
    opacity: 0.4,
    fill: "#FFFFFF",
    stroke: "#000000",
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    cx: 1538,
    cy: -1296.734,
    r: 77.25
  }), /*#__PURE__*/React.createElement("circle", {
    display: "inline",
    opacity: 0.4,
    fill: "#FFFFFF",
    stroke: "#000000",
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    cx: 1094,
    cy: -1296.734,
    r: 77.25
  }), /*#__PURE__*/React.createElement("circle", {
    display: "inline",
    opacity: 0.4,
    fill: "#FFFFFF",
    stroke: "#000000",
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    cx: 189,
    cy: -1295.734,
    r: 77.25
  }), /*#__PURE__*/React.createElement("circle", {
    display: "inline",
    opacity: 0.4,
    fill: "#FFFFFF",
    stroke: "#000000",
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    cx: 868.5,
    cy: -1301.734,
    r: 77.25
  }), /*#__PURE__*/React.createElement("circle", {
    display: "inline",
    opacity: 0.4,
    fill: "#FFFFFF",
    stroke: "#000000",
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    cx: 417,
    cy: -1296.734,
    r: 77.25
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Instructions_and_Tone"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Shadow_Layer"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#633FDA",
    cx: 90.5,
    cy: 90.5,
    r: 77.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F6F6F6",
    d: "M132.172,125.338c0,5.781-0.756,6.734-0.751,12.515c0.004,4.339-3.499,4.628-7.828,4.635 c-6.299,0.009-12.597,0-18.896-0.003c-0.398,0-0.799,0.004-1.195-0.034c-1.866-0.178-2.569-0.866-2.585-2.749 c-0.041-4.744,0.833-6.22,1.417-11.259c0.216-1.859-0.139-7.241-0.359-9.092c2.437-23.004-4.254-23.205-9.62-23.385 c-5.7-0.191-14.17,3.224-15.252,8.751c-0.213,1.086-0.641,17.992-0.647,19.101c-0.03,5.183,1.686,8.979,1.685,14.162 c0,0.439,0.007,0.878-0.014,1.315c-0.119,2.465-0.853,3.214-3.293,3.221c-6.339,0.02-12.677,0.03-19.016-0.001 c-3.26-0.016-6.031-1.078-7.264-4.359c-0.503-1.34-1.22-5.012-1.227-6.463c-0.052-10.844-0.75-6.532-0.75-17.377 c0.776-11.505,2.262-14.938,2.25-15.377c-0.04-1.527-4.347-2.305-7.336-2.308c-3.8-0.004-8.714,0.992-8.716-2.771 c-0.001-2.033,8.626-14.541,10.096-15.766c7.172-9.454,11.085-12.266,19.336-18.703c1.931-1.506,7.876-7.824,9.839-9.199 c6.426-4.501,9.787-8.753,19.543-11.728c11.449,0.916,27.404,18.694,31.905,22.44c13.128,13.892,24.742,33.17,24.73,35.721 c-0.008,1.72-6.196,0.304-7.938,0.305c-3.428,0.002-6.516-1.028-10.116,1.144c-1.497,0.904-0.124,8.003-0.127,9.741 c-0.01,5.861,0.98,3.967,0.98,9.828C131.025,117.645,132.17,125.338,132.172,125.338z"
  })));
};
export default __webpack_public_path__ + "static/media/home.077aa923.svg";
export { SvgComponent as ReactComponent };